<template>
  <div>
    <b-row>
      <b-col lg="2">
        <span class="fieldHeader">{{$t('privatePage.logicTestLevel_desc')}}:</span>
          {{question.difficultyLevel}}
      </b-col>
    </b-row>
    <h5>{{ $t('questionalternative') }}</h5>
      <b-list-group>
    <b-row>
        <b-col v-for="(alternative, alternativeIndex) in question.alternatives"
                :key="alternativeIndex">
          <b-card v-show="question.hasNumericalImages">
            {{alternative.text}}
          </b-card>
          <b-card v-show="!question.hasNumericalImages">
            <b-img fluid
                :src="alternative.imageUrl"
                alt="" />
          </b-card>
        </b-col>
    </b-row>
      </b-list-group>
  </div>
</template>

<script>

export default {
  name: 'display-module-gfair',
  props: {
    question: {}
  }
}
</script>
